import {NavigationPathKey, TranslationKey} from '@enums'
import contractsCardImage from '@images/contracts-card.jpg'
import creditDecisionImage from '@images/credit-decision-card.jpg'
import templatesCardImage from '@images/templates-card.jpg'
import {Stack, useMediaQuery, useTheme} from '@mui/material'
import {pageLinksAtom} from '@state'

import {useEffect} from 'react'

import {TitleLink} from 'common/types'
import {useSetAtom} from 'jotai'
import {useTranslation} from 'react-i18next'

import {ComposedComponents} from '@components'

/**
 * Contracts Dashboard page with navigation cards
 */
export function ContractsDashboardPage() {
  const {t} = useTranslation()

  const theme = useTheme()
  const setTitleLinks = useSetAtom(pageLinksAtom)
  const isDownLg = useMediaQuery(theme.breakpoints.down('lg'))

  const titleLinks: TitleLink[] = [
    {
      title: t(TranslationKey['Admin panel']),
      link: NavigationPathKey.ADMIN_PANEL,
    },
    {title: t(TranslationKey.Contracts)},
  ]

  useEffect(() => {
    setTitleLinks(titleLinks)
  }, [titleLinks])

  const navigationCardItems: ComposedComponents.CardItem[] = [
    {
      title: t(TranslationKey['Contract types']),
      key: NavigationPathKey.CONTRACT_TYPE_SEARCH,
      image: contractsCardImage,
    },
    {
      title: t(TranslationKey['Contract templates']),
      key: NavigationPathKey.CONTRACT_TEMPLATE_SEARCH,
      image: templatesCardImage,
    },
    {
      title: t(TranslationKey['Credit Decision Configuration']),
      key: NavigationPathKey.CREDIT_DECISION,
      image: creditDecisionImage,
    },
  ]

  return (
    <Stack gap={5}>
      <ComposedComponents.NavigationCards itemsInRow={isDownLg ? 1 : 3} items={navigationCardItems} />
    </Stack>
  )
}
